module.exports = __webpack_public_path__ + "img/Calendar.8d1431ac.svg";